import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change, Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { renderAutoCompleteSingleSelect, renderCheckBox } from '../../../../components/reduxFields';
import { getPayerByPatientId, SubmitClaim, SubmitEDIClaim } from './actions/ManageClaimActions';
import { extractDataFromArray } from '../../../../actions/utilAction';

import FlatButton from 'material-ui/FlatButton';
import validate from './ValidateSubmitClaim';

class SubmitClaimModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      insuranceCompaniesList: props.insuranceCompaniesList ? props.insuranceCompaniesList : [],
      ClaimId: props.ClaimId,
      PatientId: props.PatientId,
      OrganizationId: props.OrganizationId,
      ClaimForm: [{ id: 1, value: 'Form 1500' }, { id: 2, value: 'EDI 837' }],
      // ClaimForm: [{ id: 1, value: 'Form 1500' }],
      ClaimFormPrintFormat: [{ id: 1, value: 'Normal' }, { id: 2, value: 'Pre-Printed' }],
      // ClaimFormPrintFormat: [{ id: 1, value: 'Printed' }],
      IsNonEDIPayer: false,
      IsClaimForm1500: false,
      IsEDIClaim: false,
    };
  }

  componentWillMount() {
    this.props.getPayerByPatientId(this.state.PatientId, 'PRIMARY');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.downloadStatus && this.props.downloadStatus !== nextProps.downloadStatus) {
      // this.setState({ open: false });
      // this.props.closeDialog();
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      let masterData = nextProps.master_data;
      this.setState({
        masterPractitionerList: masterData.allStaffs,
      });
    }

    if (nextProps.insuranceCompaniesList && this.props.insuranceCompaniesList !== nextProps.insuranceCompaniesList) {
      this.setState({
        insuranceCompaniesList: nextProps.insuranceCompaniesList,
      });
    }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord) => {
   
    if (input.name === 'insuranceCompanyId') {
      if (selectedRecord.value !== '') {
        let objInsuranceCompanies = extractDataFromArray(this.state.insuranceCompaniesList, selectedRecord.value);
        if (objInsuranceCompanies.payerPreference === 'Primary') {          
          this.props.dispatch(change('SubmitClaimModal', 'claimFormPrintFormat', objInsuranceCompanies.form1500PrintFormat));
          if (objInsuranceCompanies.isEDIPayer) {            
            this.setState({ IsNonEDIPayer: false, IsClaimForm1500: false, ClaimForm: [{ id: 1, value: 'Form 1500' }, { id: 2, value: 'EDI 837' }] });
          } else {            
            this.setState({ IsNonEDIPayer: true, IsClaimForm1500: true, ClaimForm: [{ id: 1, value: 'Form 1500' }] });
          }
        }
      } else {
        this.props.dispatch(change('SubmitClaimModal', 'markSubmitted', false));
        this.setState({
          ClaimForm: [{ id: 1, value: 'Form 1500' }, { id: 2, value: 'EDI 837' }],
          ClaimFormPrintFormat: [{ id: 1, value: 'Normal' }, { id: 2, value: 'Pre-Printed' }],
          // ClaimFormPrintFormat: [{ id: 1, value: 'Printed' }],
          IsNonEDIPayer: false,
          IsClaimForm1500: false,
          IsEDIClaim: false,
        });
      }
    } else if (input.name === 'claimForm') {
      if (selectedRecord.value !== '') {
        if (selectedRecord.value === 1) {
          this.props.dispatch(change('SubmitClaimModal', 'markSubmitted', false));
          this.setState({ IsClaimForm1500: true, IsEDIClaim: false });
        } else if (selectedRecord.value === 2) {
          this.props.dispatch(change('SubmitClaimModal', 'markSubmitted', true));
          this.setState({ IsClaimForm1500: false, IsEDIClaim: true });
        }
      } else {
        this.props.dispatch(change('SubmitClaimModal', 'markSubmitted', false));
        this.setState({ IsClaimForm1500: false, IsEDIClaim: false });
      }
    }

    input.onChange(selectedRecord.value);
  }

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  onSubmitHandler(formData) {
    let markSubmitted = formData.markSubmitted ? true : false;
    // let claimForm = formData.claimForm;
    let claimFormPrintFormat = formData.claimFormPrintFormat;
    // console.log('formData.claimForm.................',formData.claimForm)
    if (formData.claimForm === 1) {
      this.props.SubmitClaim(this.state.ClaimId, formData.insuranceCompanyId, markSubmitted, claimFormPrintFormat);
    } else {
      this.props.SubmitEDIClaim(this.state.ClaimId, formData.insuranceCompanyId);
    }
    this.handleClose();
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <Dialog className="custom_modal"
        title={'Generate Claim CL' + this.props.ClaimId}
        modal={false}
        open={this.state.open}
        autoScrollBodyContent={true}>
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-6 require mt-35">
                  <Field
                    name="insuranceCompanyId"
                    label="Payer Name"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.insuranceCompaniesList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className='col-sm-6 require mt-35' >
                  <Field
                    name="claimForm"
                    label="Claim Form"
                    options={this.state.ClaimForm}
                    handleNewRequest={this.handleNewRequest}
                    component={renderAutoCompleteSingleSelect} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 mt-40">
                  <Field
                    name="markSubmitted"
                    label="Mark Submitted"
                    // defaultChecked={this.state.IsClaimForm1500 ? false : true}
                    disabled={this.state.IsEDIClaim ? true : false}
                    component={renderCheckBox} />
                </div>
                {this.state.IsClaimForm1500 ?
                  <div className='col-sm-6 require  mt-35' >
                    <Field
                      name="claimFormPrintFormat"
                      label="Print Formats"
                      options={this.state.ClaimFormPrintFormat}
                      handleNewRequest={this.handleNewRequest}
                      component={renderAutoCompleteSingleSelect} />
                  </div>
                  : null}
              </div>

              <div className="row">
                <div className="col-sm-6 require mt-40">
                </div>
                <div className="col-sm-6 pt20 btn_rt">
                  <FlatButton className="grey_btn"
                    label="Cancel" onTouchTap={this.handleClose} />
                  <FlatButton className="blue_btn"
                    label="Generate Claim" primary={true} type='submit' />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  };
}

SubmitClaimModal = reduxForm({
  form: 'SubmitClaimModal',
  validate,
  enableReinitialize: true,
})(SubmitClaimModal);

function mapStateToProps(state, ownProps) {
  // console.log('state.billing.insuranceCompaniesList.data............',state.billing.insuranceCompaniesList)
  return {
    ClaimId: ownProps.ClaimId,
    PatientId: ownProps.PatientId,
    OrganizationId: ownProps.OrganizationId,
    insuranceCompaniesList: state.billing.insuranceCompaniesList.data,
    downloadStatus: state.billing.downloadStatus,
  };
}

export default connect(mapStateToProps, { getPayerByPatientId, SubmitClaim, SubmitEDIClaim })(SubmitClaimModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/SubmitClaim_Modal.js